import { render, staticRenderFns } from "./readyPaymentError.vue?vue&type=template&id=0968e9fe"
import script from "./readyPaymentError.vue?vue&type=script&lang=js"
export * from "./readyPaymentError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports